import { initReactI18next } from "react-i18next";

import i18n from "i18next";
// For lazy loading for translations: https://github.com/i18next/i18next-http-backend
import detector from "i18next-browser-languagedetector";
// https://react.i18next.com/latest/using-with-hooks
import Backend from "i18next-http-backend";

// For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector

export const i18nInitPromise = i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // locale files path
    },
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: ["en"],
  });

export default i18n;
